import { authHeader } from "../../_helpers/auth-header";
import { appConfig, headerConfig } from "../../config";
import auth from "../auth";

export const countryCityService = {
  add_city,
  get_state,
  get_all_city,
  delete_city,
  get_city_details,
  get_citydetails_ByState,
  get_country_data,
  update_city,
  get_timezone
};

function refineHeader() {
  let token = auth.getToken();
  if (token != "") {
    headerConfig.headerDatas["Authorization"] = "Bearer " + token;
  }
}

function add_city(propsData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(propsData)
  };

  return fetch(`${appConfig.api.url}city/add`, requestOptions)
    .then(handleResponse)
    .then(city => {
      return city;
    });
}

function get_state(countryNameParams) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify()
  };

  return fetch(
    `${appConfig.api.url}public-city/state/${countryNameParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(states => {
      return states;
    });
}

function get_all_city(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}city/list`, requestOptions)
    .then(handleResponse)
    .then(cities => {
      return cities;
    });
}

function delete_city(cityIdASParams) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(cityIdASParams)
  };

  return fetch(
    `${appConfig.api.url}city/delete/${cityIdASParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(city => {
      return city;
    });
}

function get_city_details(cityIdParams) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify()
  };

  return fetch(
    `${appConfig.api.url}city/detail/${cityIdParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(cityDetails => {
      return cityDetails;
    });
}

function get_citydetails_ByState(stateAbbr) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify()
  };

  return fetch(`${appConfig.api.url}city/${stateAbbr}`, requestOptions)
    .then(handleResponse)
    .then(cityDetailsByState => {
      return cityDetailsByState;
    });
}

function get_country_data() {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify()
  };

  return fetch(`${appConfig.api.url}public-city/country`, requestOptions)
    .then(handleResponse)
    .then(countries => {
      return countries;
    });
}

function update_city(propsData) {
  refineHeader();
  const requestOptions = {
    method: "PUT",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(propsData)
  };

  return fetch(`${appConfig.api.url}city/edit`, requestOptions)
    .then(handleResponse)
    .then(updatedCity => {
      return updatedCity;
    });
}

function get_timezone() {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify()
  };

  return fetch(`${appConfig.api.url}city/timezone`, requestOptions)
    .then(handleResponse)
    .then(timezone => {
      return timezone;
    });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}



// WEBPACK FOOTER //
// ./src/app/services/API/countryCityService.js